import { useCallback } from 'react'

import { QuizAttemptResultType, QuizAttemptSubmissionType } from 'app/types'
import { request } from 'modules'

import { QUIZ_ATTEMPTS_ENDPOINT } from './use-quiz-statuses'

// embed has no shared mutation hook, so we call `request` directly (POST the attempt, fire-and-forget)
export const useSubmitQuizAttempt = () => {
    const submitAttempt = useCallback(
        (body: QuizAttemptSubmissionType): Promise<QuizAttemptResultType> =>
            request(QUIZ_ATTEMPTS_ENDPOINT, 'POST', body),
        [],
    )

    return { submitAttempt }
}
